<script setup lang="ts">
    import type { TrainingsListingItem } from '~/types/academy/baseTraining';
    import academyBackground from '~/assets/images/academy-background.svg';

    const props = defineProps<{
        item: TrainingsListingItem;
        square?: boolean;
        wide?: boolean;
        href?: string;
        openNewTab?: boolean;
        completed?: boolean;
    }>();

    const NuxtLink = resolveComponent('NuxtLink');

    const image = computed(() => {
        if (props.item.image?.src) {
            return props.item.image;
        }

        return { src: academyBackground, alt: props.item.title };
    });
</script>

<template>
    <div class="teaser-image">
        <component
            :is="href ? NuxtLink : 'div'"
            :href="href ?? undefined"
            :target="href && openNewTab ? '_blank' : undefined"
            class="teaser-image-inner"
            :class="{ completed: completed }"
        >
            <img
                :src="image.src"
                :alt="image.alt ?? item.title"
                :class="{ square: square, wide: wide, completed: completed }"
                :width="image.width ?? undefined"
                :height="image.height ?? undefined"
            />
            <TeaserPoints
                v-if="item.type === 'course' && item.points"
                :points="item.points"
            />
        </component>
        <slot name="badges" />
    </div>
</template>

<style scoped lang="scss">
    .teaser-image {
        position: relative;
        padding: $spacing $spacing 0;
        overflow: visible;
        flex-shrink: 0;

        .teaser-image-inner {
            display: block;
            position: relative;

            &.completed {
                background-color: var(--white);
                border-radius: var(--border-radius-s);
            }
        }

        img {
            width: 100%;
            object-fit: contain;
            display: block;
            border-radius: $border-radius-s;

            &.square {
                aspect-ratio: 1/1;
                object-fit: cover;
            }

            &.wide {
                aspect-ratio: 2/1;
                object-fit: cover;
            }

            &.completed {
                opacity: 0.5;
            }
        }
    }
</style>
